import React, { useEffect } from 'react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import { Grid, makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import useDashboard from '@hooks/useDashboard';

const RfqRequestEmpty = () => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const onClick = () => history.push('/request');

  const { onInitSelectedQuotation } = useDashboard();

  useEffect(() => {
    onInitSelectedQuotation();
  }, [onInitSelectedQuotation]);

  return (
    <Grid
      className={classes.root}
      container
      justifyContent="center"
      alignItems="center"
      direction="column"
    >
      <CustomizedTypography
        className={classes.text}
        variant={!matches ? 'h4' : 'body1'}
        color="textSecondary"
        align="center"
        gutterBottoms={32}
      >
        아직 견적요청을 하지 않았어요.
        <br />
        가장 빠른 견적요청, 바로 시작해 보세요!
      </CustomizedTypography>

      <CustomizedButton
        color="primary"
        variant="contained"
        size="large"
        onClick={onClick}
      >
        <i className="request-gtm-startMakeRFQ-btn">견적 요청하기</i>
      </CustomizedButton>
    </Grid>
  );
};

export default RfqRequestEmpty;

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    backgroundColor: colorSet.gray000,
    position: 'fixed',
    top: 0,
    zIndex: 1100
  },
  text: {
    color: '#CED4DA'
  }
}));
